/* eslint-disable import/prefer-default-export */
export const specificMarketColumns = [
    {
        title: "Category",
        dataIndex: "item",
        key: "item"
    },
    {
        title: "Relevance",
        dataIndex: "score",
        key: "score",
        width: 200
    }
];

export const audienceSpicificColumns = [
    {
        title: "Category",
        dataIndex: "item",
        key: "item"
    },
    {
        title: "Relevance",
        dataIndex: "score",
        key: "score"
    },
    {
        title: "Size",
        dataIndex: "share",
        key: "share"
    }
];

export const highlyEngagedObj = {
    title: "Highly Engaged",
    key: "Highly Engaged",
    type: "value",
    color: "#00C18D",
    filter: "behavior"
};

export const activelyInterestedObj = {
    title: "Actively Interested",
    key: "Actively Interested",
    type: "value",
    color: "#14B2E2",
    filter: "behavior"
};

export const consciouslyReceptiveObj = {
    title: "Consciously Receptive",
    key: "Consciously Receptive",
    type: "value",
    color: "#FCA522",
    filter: "behavior"
}

export const subConsciouslyReceptiveObj = {
    title: "Subconsciously Receptive",
    key: "Subconsciously Receptive",
    type: "value",
    color: "#E54D42",
    filter: "behavior"
}

export const unAwareObj = {
    title: "Unaware",
    key: "Unaware",
    type: "value",
    color: "#E54D42",
    filter: "behavior"
}

export const deepDiveColumns = [
    {
        title: "Insights",
        key: "insights",
        align: "center",
        csv: false
    },
    {

        title: "Behavior",
        key: "item"
    },
    {
        title: "Behavior Match",
        key: "behaviormatch",
        filter: "behavior"
    },
    highlyEngagedObj,
    activelyInterestedObj,
    consciouslyReceptiveObj,
    subConsciouslyReceptiveObj,
    unAwareObj,
    {
        title: "Interest Level",
        key: "score"
    },
    {
        title: "Segment Size",
        key: "share",
        align: "right"
    },
    // {
    //     title: "Master Size",
    //     key: "masterSize",
    //     align: "right"
    // },
    {
        title: "Target Size",
        key: "audienceIntersect",
        align: "right",
        excludeDownloadWhenModule: ["facebookaudiences", "yahoodisplay", "lineaudience"],
        excludeDownloadWhenAnalysis: ["tiktokhastags", "analysis_gdn&trv_affinity",
            "analysis_gdn&trv_purchase",
            "analysis_gdn&trv_topic"]
    }
];
